module.exports = __webpack_public_path__ + "static/media/home.700fb41b.jpg";